import { styled } from "@mui/material/styles";

import { StyledHtml } from "@/components/html/html.styles";

export const StyledLWC = styled(StyledHtml)`
  h1 {
    font-weight: normal;
  }
  .siteForecasts {
    width: auto;
    float: left;
    margin-right: 1em;
    min-width: auto;
    max-width: none;
  }
  fieldset {
    margin-top: 1em;
  }
  .route-name {
    font-weight: bold;
  }
  thead {
    background: #f3f3f3;
    color: #0a0a0a;
  }
  thead,
  tbody {
    border: 1px solid #dedede;
  }
  td,
  th.siteId {
    background: none;
    text-align: right;
  }
  td,
  th {
    padding: 0 0.5em;
  }
  th.siteId {
    font-weight: bold;
  }
  th.siteName {
    color: #0a0a0a;
  }
  td.temp {
    color: #01689b;
  }
  td.temp_red {
    color: #ce1f00;
  }
`;
